import { Component } from "react";
import ReactDOM from "react-dom";
import {
    DKInputForm,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    isEmpty,
    DKSpinner,
    DKIcons,
    DKButton
} from "deskera-ui-library";
import { COLUMN_CODE, TableManger, TABLES } from "../managers/TableManger";
import DataGridUtility from "../utility/DataGridUtility"
import Table from "../services/table";
import { showAddColumnPopup } from "../components/common/AddColumnPopup";
import TenantManager from "../managers/TenantManager";
import { biWeeklyPayDays, COUNTRY_CODE, DATE_FORMAT, INPUT_TYPE, payDayMonthly, payDayTwicePerMonthDays, payPeriod, workWeek } from "../constants/Constant";
import Popup from "../components/common/Popup";
import { PayrollManager } from "../managers/PayrollManager";
import { ADD_PAYROLL_DATA_TO_SAVE } from "../Models/AddPayroll";
import PayrollService from "../services/PayrollService";
import { fetchPayrolls } from "../Redux/Slices/PayrollSlice";
import moment from "moment";
import RouteManager, { PAGE_ROUTES } from "../managers/RouteManager";
import { TENANT, TenantService } from "../managers/TenantManagerService";
import { PayScheduleManager } from "../managers/PayScheduleManager";
import i18next from 'i18next';
import Utility, { deepClone } from '../utility/Utility';
import PayScheduleService from "../services/PayScheduleService";
import { convertDateToJson } from "../managers/common/CommonUtil";

export interface IAddNewRecordPopUpProps {
    tableName: string;
    recordId?: string;
    id: string;
    onSave?: (data: any) => void;
    onClose?: () => void;
    defaultValues: any;
    displayName: string;
    isCustomForm: boolean;
    inputData: any;
}
export interface IAddNewRecordPopUpState {
    formFields: any[];
    count: number
}
class AddPayrollPopUp extends Component<
    IAddNewRecordPopUpProps,
    IAddNewRecordPopUpState
> {
    columns = [];
    isUpdated: boolean = false;
    defaultValues: any[] = [];
    paySchedules : any[] = [];
    usersList : any[] = [];
    locationList: any[] = [];
    tenantData : any = {};
    isValueUpdated = true;
    trackLocation = false
    defaultOldValues = []
    customFields = [];
    constructor(props) {
        super(props);
        let paySchedules = this.props.inputData.payscheduleList
        this.state = {
            formFields: [],
            count : 0
        };
        this.defaultValues = this.props.defaultValues;
        this.isUpdated = !isEmpty(this.props.recordId);
        this.paySchedules = this.props.inputData.paySchedules || [];
        this.usersList = this.props.inputData.users || [];
        this.tenantData = this.props.inputData.tenantData || {};
        this.defaultOldValues = deepClone(this.props.defaultValues);
        this.customFields = this.props.inputData?.customFields?.customFields?.filter(field=>field.isActive) || [];

        if(Utility.isEmpty(this.usersList)) {
            this.getUsers()
        } else {
            this.updateSelectedUser()
        }
        if(Utility.isEmpty(this.paySchedules)) {
            this.getPaySchedule()
        } else {
            this.updateSelectedPaySchedule()
        }
        const tenantDetails = TenantManager.getTenantDetails()
        const additionalSettings = tenantDetails
        ? tenantDetails.additionalSettings
        : "";
        const locationSettings = additionalSettings ? additionalSettings?.['LOCATION'] : {};
        this.trackLocation = locationSettings?.trackLocation || false;

        if(this.trackLocation && this.props.inputData?.locationList){
            const locations = this.props.inputData.locationList.map((x) => {
                return {
                    id : x.id,
                    name: x.label,
                };
            });
            this.locationList = locations ? locations : []

        }

    }
    componentDidMount() {
        this.buildForm(true);
    }
    getUsers() {
        showLoader()
        PayrollService.getUsersList().then((res:any)=>{
            removeLoader()
            if(res && res.users) {
                let employeeId = this.defaultOldValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.USERS
                  )];
                if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
                    employeeId = employeeId.filter(e=> res.users?.findIndex(u=>u.userId==e) !=-1)
                    employeeId = employeeId.map(emp=>{
                        return res.users.findIndex(user=> 
                            user.userId==emp
                            
                        )
                    })
                }
                this.defaultValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.USERS
                  )] = employeeId;
                this.usersList = res.users;
                this.setState({
                    ...this.state
                })
                this.buildForm(false);
            }
        });
    }
    getUsersByLocation(location) {
        showLoader()
        PayrollService.getUsersByLocation(location).then((res:any)=>{
            removeLoader()
            if(res && res.users) {
                let employeeId = this.defaultOldValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.USERS
                  )];
                if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
                    employeeId = employeeId.filter(e=> res.users?.findIndex(u=>u.userId==e) !=-1)
                    employeeId = employeeId.map(emp=>{
                        return res.users.findIndex(user=> 
                            user.userId==emp
                            
                        )
                    })
                }
                this.defaultValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.USERS
                  )] = employeeId;
                this.usersList = res.users;
                this.setState({
                    ...this.state
                })
                this.buildForm(false);
            }
        });
    }
    updateSelectedUser() {
        let employeeId = this.defaultOldValues[TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.USERS
          )];
        if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
            employeeId = employeeId.filter(e=> this.usersList?.findIndex(u=>u.userId==e) !=-1)
        }
        this.defaultValues[TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.USERS
          )] = employeeId;
        let loc = this.defaultOldValues[TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.LOCATION
        )];
        
        if (!Utility.isEmpty(this.defaultOldValues) && loc) {
           (Utility.isEmpty(loc[0])) ? this.getUsers() : this.getUsersByLocation(loc[0])
        }       
    }
    getPaySchedule() {
        PayrollService.getPayScheduleList().then(res=>{
            if(res && res['schedules']) {
                let paySchedule = this.defaultOldValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE
                  )];
                this.paySchedules = res['schedules'];
                if(!Utility.isEmpty(this.defaultOldValues) && paySchedule) {
                    paySchedule = paySchedule.filter(e=> res['schedules']?.findIndex(u=>u.id==e) !=-1)
                    paySchedule = paySchedule.map(emp=>{
                        return res['schedules'].findIndex(user=> 
                            user.id==emp
                            
                        )
                    })
                }
                this.defaultValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE
                  )] = paySchedule;
                  this.buildForm(false);
            }
        });
    }
    updateSelectedPaySchedule() {
        let employeeId = this.defaultOldValues[TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE
          )];
        if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
            employeeId = employeeId.filter(e=> this.paySchedules?.findIndex(u=>u.id==e) !=-1)
        }
        this.defaultValues[TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE
          )] = employeeId;
    }
    buildForm = (params) => {
        this.columns = this.updateColumnConfig(params);
        this.putAdditionalFields().then(() => {
            let formFields = DataGridUtility.getFormElements(
                this.columns,
                this.defaultValues
            );
            this.setState({
                formFields,
            });
            this.forceStateUpdate()
        });
    }
    forceStateUpdate = () => {
        this.setState({
            count: this.state.count + 1
        });
    }

    updateColumnConfig = (params) => {
        let columnConfig = [];
        columnConfig = params ? JSON.parse(JSON.stringify(TableManger.getTableColumns("people_add_payroll").filter(
            (obj) => obj.editable && obj.uiVisible
        ))) : this.columns.filter(
            (obj) => obj.editable && obj.uiVisible
        );
        columnConfig = this.updateColumnConfigWithCustomField(columnConfig);
        return columnConfig;
    }

    removePopUp = () => {
        ReactDOM.unmountComponentAtNode(document.getElementById(this.props.id));
        document.getElementById(this.props.id)?.remove();
    }
    onClose = () => {
        if (this.props.onClose) this.props.onClose();
        this.removePopUp();
    };
    onSave = (data) => {
        switch(this.props.tableName) {
            case TABLES.ADD_PAYROLL:
                this.addDataToPayroll(data);
        }
    };

    addDataToPayroll(data) {

        let workPeriodFromColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_FROM);
        let workPeriodToColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_To);
        let workWeekColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_WEEKS);
        
        if(PayScheduleManager.workWeekDaysValid(data[workWeekColumnId])) {
            showToast(i18next.t("COMPANY_WORK_WEEK_LIMIT"), TOAST_TYPE.FAILURE);
            return
        }
        if(data[workPeriodFromColumnId].getTime() > data[workPeriodToColumnId].getTime()) {
            showToast("Please ensure that the Work Period To Date is greater than the Work Period From Date.", TOAST_TYPE.FAILURE);
            return
        }

        let payScheduleColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL,COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE);
        let payPeriodColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD);
        
        let payDayColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DAY);
        let payDateColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DATE);
        let applicableToColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL);
        let usersColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.USERS);
        let locationColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.LOCATION);

        let payScheduleOptions = [];
        let payPeriodOptions = [];
        let workweekOptions = [];
        let payDayOptions = [];
        let applicableToOptions = [];
        let usersOptions = [];

        this.columns.forEach(column => {
            switch(column.columnCode) {
                case COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE:
                    payScheduleOptions = column.options ? column.options : [];
                    break;
                case COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD:
                    payPeriodOptions = column.options ? column.options : [];
                    break;
                case COLUMN_CODE.ADD_PAYROLL.WORK_WEEKS:
                    workweekOptions = column.options ? column.options : [];
                    break;
                case COLUMN_CODE.ADD_PAYROLL.PAY_DAY:
                    payDayOptions = column.options ? column.options : [];
                    break;
                case COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL:
                    applicableToOptions = column.options ? column.options : [];
                    break;
                case COLUMN_CODE.ADD_PAYROLL.USERS:
                    usersOptions = column.options ? column.options : [];
                    break;
            }
        });

        let isApplicableToAll = data[applicableToColumnId] ? this.isApplicableToAll(data[applicableToColumnId][0]) : true;
        const customFieldsValues = this.getCustomFieldsData(data);

        let paramters: ADD_PAYROLL_DATA_TO_SAVE = {
            countryCode: this.tenantData && this.tenantData.countryCode ? this.tenantData.countryCode: "",
            tenantId: this.tenantData && this.tenantData.erpTenantId ? this.tenantData.erpTenantId : 0,
            deleted: false,
            payrunType: 1,
            location: data[locationColumnId] && data[locationColumnId][0] ? data[locationColumnId][0] : "",
            paySchedule: {
                id: data[payScheduleColumnId] ? data[payScheduleColumnId][0]: "",
                name: this.getPayScheduleName(payScheduleOptions, data[payScheduleColumnId][0])
            },
            payPeriod: data[payPeriodColumnId] ? data[payPeriodColumnId][0] : "",
            workWeek: data[workWeekColumnId],
            payDay: data[payDayColumnId] ? data[payDayColumnId][0] : "",
            firstPayDate: this.formatDate(data[payDateColumnId]),
            payDate: this.formatDate(data[payDateColumnId]),
            workPeriod: {
                from: this.formatDate(data[workPeriodFromColumnId]),
                to: this.formatDate(data[workPeriodToColumnId]),
            },
            isForAllUsers: isApplicableToAll,
            employees: data[usersColumnId] || [],
            customFields: customFieldsValues
        }
        showLoader(`Payroll is being ${this.isUpdated ? "updated" : "added"}...`);
        (!this.isUpdated
            ? Table.savePayroll(paramters)
            : Table.editPayroll({ ...paramters, ...{_id: this.props.recordId}})
        ).finally(() => removeLoader())
            .then(
                (res:any) => {
                    showToast(
                        `${this.isUpdated ? "Payroll Updated" : "Payroll Added"} Successfully`,
                        TOAST_TYPE.SUCCESS
                    );
                    RouteManager.navigateToPage(
                        PAGE_ROUTES.PROCESS_PAYROLL,
                        `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.PAYROLL_GRID}&id=${res._id}&step=0`,
        )
                    this.removePopUp();
                },
                (err) => {
                    if(err === "Empty Payrun\n"){
                        showToast(
                            "Payrun criteria is not matching for any employee payroll.",
                            TOAST_TYPE.FAILURE
                        );
                    } else if(err?.trim() === "no user found for selected location") {
                        showToast(
                            "No user found for selected location.",
                            TOAST_TYPE.FAILURE
                        );
                    } else {
                        showToast(
                            "Some unknown error occurred at server. Please try after some time.",
                            TOAST_TYPE.FAILURE
                        );
                    }
                }
            );
    }

    formatDate(inputDate) {
        let formattedDate = "";
        formattedDate = moment(inputDate).format("MM/DD/YYYY")
        return formattedDate;
    }
    loadPayrolls = async (config) => {
        try {
            PayrollService.apiConfig = config;
            await this.props.inputData.payrollDispatch(fetchPayrolls());
            // console.log(payrolls)
        } catch (err) {
            console.error('Error loading payrolls: ', err);
        }
    };

    getPayScheduleName(options,id) {
        let scheduleName = "";
        let filteredData = options.filter(x => x.id === id)
        if (filteredData && filteredData.length > 0) {
            scheduleName = filteredData[0].name;
        }
        return scheduleName;
    }
    isApplicableToAll(input) {
        let isApplicable = false;
        if (input === "YES") {
            isApplicable = true;
        }
        return isApplicable;
    }
    getSelectedEmployess(selectedIndex, options) {
        let selectedUsers = [];
        if(selectedIndex && selectedIndex.length > 0) {
            selectedIndex.forEach(index => {
                selectedUsers.push(options[index].id)
            });
        }
        return selectedUsers;
    }

    onChange = async (allFields, changedData) => {
        switch (changedData.columnCode) {
            case COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL:
                this.defaultValues[changedData.id] = changedData.value;
                if (changedData && changedData.value && changedData.value.length > 0 && changedData.value[0] === 0) {
                    this.columns.forEach(element => {
                        if (element.columnCode === COLUMN_CODE.ADD_PAYROLL.USERS) {
                            element['uiVisible'] = false;
                            element['hidden'] = true;
                            element['required'] = false;
                        }

                    });
                } else if (changedData && changedData.value && changedData.value.length > 0 && changedData.value[0] === 1) {
                    let {isFieldPresent, fieldIndex} = this.checkIfColumnAlreadyExist(COLUMN_CODE.ADD_PAYROLL.USERS, this.columns);
                    let columnToAdd = TableManger.getTableColumns("people_add_payroll").filter( x=> x.columnCode === COLUMN_CODE.ADD_PAYROLL.USERS);
                    if(!isFieldPresent && columnToAdd && columnToAdd.length > 0) {
                        columnToAdd[0]['uiVisible'] = true;
                        columnToAdd[0]['hidden'] = false;
                        columnToAdd[0]['required'] = true;
                        this.columns.push(columnToAdd[0]);
                    } else if(isFieldPresent && fieldIndex != -1) {
                        this.columns[fieldIndex]['uiVisible'] = true;
                        this.columns[fieldIndex]['hidden'] = false;
                        this.columns[fieldIndex]['required'] = true;
                    }
                } else {
                    this.columns.forEach(element => {
                        if (element.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES) {
                            element['uiVisible'] = false;
                            element['hidden'] = true;
                            element['required'] = false;
                        }

                    });
                }
                this.buildForm(false);
                break;

            case COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE:
                this.defaultValues[changedData.id] = changedData.value;
                let columnsData = this.columns.filter(x => x.columnCode === changedData.columnCode);
                if (columnsData && columnsData.length > 0 && columnsData[0]['options'] && columnsData[0]['options'].length > 0)  {
                    const selectedPayschedule = changedData.value && changedData.value.length > 0 ? columnsData[0]['options'][changedData.value[0]]: {};
                    if (!Utility.isEmpty(selectedPayschedule.location)) {
                        showLoader();
                        const userResponse: any = await PayrollService.getUsersByLocation(selectedPayschedule.location);
                        if (userResponse?.users) {
                            this.usersList = userResponse.users;
                        }
                        removeLoader();
                    }

                    this.updateValuesOnSelectedPayroll(selectedPayschedule);
                    if (selectedPayschedule.isForAllUsers) {
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL)] = [0];
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.USERS)] = [];
                        this.updateFormFieldColumns(0);
                    } else if (selectedPayschedule.employees && (selectedPayschedule.employees.length > 0)) {
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL)] = [1];
                        let employeeId = selectedPayschedule.employees;
                        if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
                            employeeId = employeeId.filter(e=> this.usersList?.findIndex(u=>u.userId==e) !=-1)
                        }
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.USERS)] = employeeId; 
                        this.updateFormFieldColumns(1);
                    } else {
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL)] = [0];
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.USERS)] = [];
                    }
                    let filterData = this.columns.filter(x => x.columnCode === COLUMN_CODE.ADD_PAYROLL.PAY_DAY)
                    if(filterData[0]) {
                        filterData[0].options = this.getOptions(selectedPayschedule['payPeriod'])
                        PayrollManager.getDataToUpdateForPayrollEmployees(this.defaultValues, filterData);
                    }

                    if (Utility.isEmpty(selectedPayschedule.location)) {
                        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.LOCATION)] = [""];
                    }
                }
                
                PayrollManager.getDataToUpdateForPayrollEmployees(this.defaultValues, this.columns.filter(x => x.columnCode === COLUMN_CODE.ADD_PAYROLL.USERS));
                PayrollManager.getDataToUpdateForPayrollEmployees(this.defaultValues, this.columns.filter(x => x.columnCode === COLUMN_CODE.ADD_PAYROLL.LOCATION));
                this.buildForm(false);
                break;
            case COLUMN_CODE.ADD_PAYROLL.PAY_DAY:
                this.defaultValues[changedData.id] = changedData.value;
                let payeriodColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD);
                let selectedPayPeriod = this.defaultValues[payeriodColumnId]
                
                
                if (changedData.value.length != 0) {
                    this.updateFirstPayDate(selectedPayPeriod[0],changedData.value[0],changedData)
                }
                this.buildForm(false);
                break;
            case COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD:
                this.defaultValues[changedData.id] = changedData.value;
                if (changedData.value.length != 0) {
                    this.updateFirstPayDate(changedData.value[0],'0',changedData)
                }
                this.buildForm(false);
                break;
            case COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK:
                this.defaultValues[changedData.id] = changedData.value;
                if (PayScheduleManager.workWeekDaysValid(changedData.value)) {
                    showToast(i18next.t("COMPANY_WORK_WEEK_LIMIT"), TOAST_TYPE.FAILURE);
                }
                break;
            case COLUMN_CODE.ADD_PAYROLL.LOCATION:
                this.defaultValues[changedData.id] = changedData.value;
                if (changedData && changedData.value.length === 1) {
                    const locName = changedData.options[changedData.value[0]]
                    const locObj = this.locationList.find(list => list.name === locName)
                    if (locObj && locObj.id) {
                        this.getUsersByLocation(locObj.id);
                    } else {
                        this.getUsers();
                    }
                    const usersColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.USERS);
                    this.defaultValues[usersColumnId] = [];
                    this.defaultOldValues[usersColumnId] = [];
                }
                this.buildForm(false);
                break;
            default:
                this.checkValidationIfAny(changedData);
                this.buildForm(false);
        }
        
    }

    checkValidationIfAny = (changedData) => {
        const validation = changedData.validation || [];
        if(!Utility.isEmpty(validation.length)) {
            validation.forEach(v => {
                for (const k in v) {
                    switch(k) {
                        case "maxLength":
                            const maxLength = parseInt(v[k]);
                            if(typeof changedData.value === "string" && changedData.value.length <= maxLength) {
                                this.defaultValues[changedData.id] = changedData.value;
                            } else if(changedData.required && typeof changedData.value === "string" && isEmpty(changedData.value)){
                                showToast(`Please enter a valid  ${changedData.title}`, TOAST_TYPE.FAILURE);
                            } else {
                                showToast(`Input length cannot be greater than ${maxLength}`, TOAST_TYPE.FAILURE);
                            }
                            break;
                        case "decimalPrecision":
                            const decimalPrecision = parseInt(v[k]);
                            const valueArray = changedData.value.split(".");
                            if(valueArray.length > 1) {
                                const precisionValue =  valueArray[1];
                                if(precisionValue.length <= decimalPrecision) {
                                    this.defaultValues[changedData.id] = changedData.value;
                                } else {
                                    showToast(`Length after decimal cannot be greater than ${decimalPrecision}`, TOAST_TYPE.FAILURE);
                                }
                            } else {
                                this.defaultValues[changedData.id] = changedData.value;
                            }

                            break;
                        default:
                            this.defaultValues[changedData.id] = changedData.value;
                    }
                }
                
            });
        } else {
            this.defaultValues[changedData.id] = changedData.value;
        }
    }

    getOptions(payPeriodType) {
        let columnCode = TableManger.getColumnId(TABLES.ADD_PAYROLL,COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD)
                    let workWeekColumnCode = TableManger.getColumnId(TABLES.ADD_PAYROLL,COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK)
        switch(payPeriodType) {
            case "monthly":
            case 0:
                return  payDayMonthly;
                
            case "weekly":
            case 1:
                let selectedWorkWeek = this.defaultValues[workWeekColumnCode]
                let options = []
                
                workWeek.forEach((w,ind)=>{
                    let i = selectedWorkWeek.findIndex(res=>w.id==res)
                    if(ind == 0 || i!=-1) {
                        options.push(w)
                    }
                })
                return options
                
            case "twicePerMonth":
            case 2:
                return payDayTwicePerMonthDays
                
            case "biWeekly":
            case 3:
                let biWeeklyPayDaysList = []
                let selectedWeek = this.defaultValues[workWeekColumnCode]
                
                selectedWeek.forEach((workDay,ind)=>{
                    if(workDay){
                        biWeeklyPayDays.forEach((day, i) => {
                        if ((workDay) === (i) || (workDay+7) === i) {
                            biWeeklyPayDaysList.push(day);
                        }
                        });
                    }
                })
                 
                return biWeeklyPayDaysList;
                
            default:
                return payDayMonthly;
                
        }
    }
    updateFirstPayDate(payPeriodInd,selectedPayDay,changedData) {

        let payDayColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DAY);
        let payDateColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DATE);
        let payPeriodColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD);
        this.defaultValues[payDayColumnId] = [selectedPayDay]
        let workWeekColumnCode = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK);

        showLoader("Fetching additonal details... Please wait.")
        const payPeriodField = this.getRespectiveField(this.columns, payPeriodColumnId);
        const workWeekField = this.getRespectiveField(this.columns, workWeekColumnCode);
        const payDayField = this.getRespectiveField(this.columns, payDayColumnId);
        const payDayOptions = !Utility.isEmpty(this.defaultValues[payPeriodColumnId]) ? this.getOptions(this.defaultValues[payPeriodColumnId][0]): [];
        const selectedPayPeriodValue = DataGridUtility.getFieldData(this.defaultValues[payPeriodColumnId], payPeriodField, payPeriodField["options"]);
        const selectedWorkweekValue = DataGridUtility.getMultiSelectFieldData(this.defaultValues[workWeekColumnCode], workWeekField, workWeekField["options"]);
        const selectedPayDayValue = DataGridUtility.getFieldData(this.defaultValues[payDayColumnId], payDayField, payDayOptions);
        const params = {
            workWeek: selectedWorkweekValue,
            payPeriod: selectedPayPeriodValue,
            payDay: selectedPayDayValue
        }
        this.getCorrespondingFieldsData(params);

    }

    getRespectiveField(columns, columnCode) {
        let field = {};
        const index = columns.findIndex(c => c.key === columnCode);
        if(index != -1) {
            field = columns[index];
        }
        return field;
    }

    getCorrespondingFieldsData(params) {
        PayrollService.getCorrespondingFields(params).finally(() => removeLoader()).then((res:any) => {
            if(!Utility.isEmpty(res)) {
                const payDateColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DATE);
                const workPeriodFromColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_FROM);
                const workPeriodToColumnId = TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_To);
                this.defaultValues[payDateColumnId] = res?.firstPayDate
                ? moment(res.firstPayDate).toDate()
                : moment().endOf('month').toDate();
                this.defaultValues[workPeriodFromColumnId] = res?.workPeriod?.from
                ? moment(res.workPeriod.from, "DD/MM/YYYY").toDate()
                : moment().endOf('month').toDate();
                this.defaultValues[workPeriodToColumnId] = res?.workPeriod?.to
                ? moment(res.workPeriod.to, "DD/MM/YYYY").toDate()
                : moment().endOf('month').toDate();

                this.buildForm(false);
            }
        })
    }

    getTheLastWorkingDay(selectedWorkDays) {
        for (let i = selectedWorkDays.length - 1; i >= 0; i--) {
            if (selectedWorkDays[i]) {
                return selectedWorkDays[i];
            }
        }
    }

    updateFormFieldColumns(isApplicable) {
        
        if(!this.trackLocation){
            this.columns = this.columns.filter(element => element.columnCode != COLUMN_CODE.ADD_PAYROLL.LOCATION)
            this.columns.forEach(element => {
                if (element.columnCode === COLUMN_CODE.ADD_PAYROLL.LOCATION) {
                    element['uiVisible'] = false;
                    element['hidden'] = true;
                    element['required'] = false;
                }

            });
        }

        if (isApplicable === 0 || isApplicable === undefined) {
            this.columns = this.columns.filter(element => element.columnCode != COLUMN_CODE.ADD_PAYROLL.USERS)
            this.columns.forEach(element => {
                if (element.columnCode === COLUMN_CODE.ADD_PAYROLL.USERS) {
                    element['uiVisible'] = false;
                    element['hidden'] = true;
                    element['required'] = false;
                }

            });
        } else {
            let columnToAdd = TableManger.getTableColumns("people_add_payroll").filter(x => x.columnCode === COLUMN_CODE.ADD_PAYROLL.USERS);
            if (columnToAdd && columnToAdd.length > 0) {
                let isPresent = this.columns.some(x => x.columnCode === columnToAdd[0].columnCode);
                const processedData = PayrollManager.parseUserList(this.usersList);
                if (isPresent) {
                    this.columns.forEach(element => {
                        if (element.columnCode === COLUMN_CODE.ADD_PAYROLL.USERS) {
                            element['uiVisible'] = true;
                            element['hidden'] = false;
                            element['required'] = true;
                            element["options"] = processedData;
                        }

                    });
                } else {
                    columnToAdd[0]['uiVisible'] = true;
                    columnToAdd[0]['hidden'] = false;
                    columnToAdd[0]['required'] = true;
                    columnToAdd[0]["options"] = processedData;
                    this.columns.push(columnToAdd[0]);
                }
            }
        }
    }

    updateValuesOnSelectedPayroll(selectedPayschedule) {
        let pyPriod = payPeriod.findIndex(res=>res.id==selectedPayschedule.payPeriod) 
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD)] =  [pyPriod]
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DAY)] = selectedPayschedule.payDay ? [selectedPayschedule.payDay] : ["lastWorkingDayMonth"];
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_WEEKS)] = selectedPayschedule.workWeek ? selectedPayschedule.workWeek : [1,2,3,4,5];
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.LOCATION)] = selectedPayschedule.location ? [selectedPayschedule.location] : [0];
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DATE)] = selectedPayschedule.firstPayDate
            ? moment(new Date(selectedPayschedule.firstPayDate), "YYYY-MM-DD").toDate()
            : moment().toDate();
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_FROM)] = selectedPayschedule.workPeriod && selectedPayschedule.workPeriod.from
              ? moment(selectedPayschedule.workPeriod.from, "DD/MM/YYYY").toDate()
              : "";
        this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_To)] = selectedPayschedule.workPeriod && selectedPayschedule.workPeriod.to
              ? moment(selectedPayschedule.workPeriod.to, "DD/MM/YYYY").toDate()
              : "";
        
    }

    getCustomFieldsData = (data) => {
        const customFieldsData = [];
        this.customFields.forEach((c) => {
            if(!Utility.isEmpty(data[c.id])) {
                let group = {
                    fieldId: c.id,
                    fieldName: c.name,
                    fieldValue: c.type === "date" ? [convertDateToJson(data[c.id])] : this.getCustomFieldInputValue(data[c.id])
                };
                customFieldsData.push(group);
            }
        });
        return customFieldsData;
    }

    getCustomFieldInputValue = (value) => {
        let selectedValue = [];
        if(Array.isArray(value)) {
            selectedValue = value;
        } else {
            selectedValue.push(value);
        }
        return selectedValue;
    }

    checkIfColumnAlreadyExist = (columnCode, columns) => {
        let isFieldPresent = false;
        let fieldIndex = -1;
        fieldIndex = columns?.findIndex((c) => c.columnCode === columnCode);
        if( fieldIndex != -1) {
            isFieldPresent = true;
        }
        return {isFieldPresent, fieldIndex}
    }
    

    render() {
        return (
            <Popup>
                {this.state.formFields.length !== 0 && (
                    <>
                        <DKInputForm
                            title={`${this.isUpdated ? "Edit" : "Add"} ${this.props.displayName}`}
                            fields={this.state.formFields}
                            onCancel={() => this.onClose()}
                            onChange={this.onChange}
                            onSubmit={(data) => {
                                this.onSave(DataGridUtility.getRowData(data, this.columns));
                            }}
                        />
                        {this.props.tableName != TABLES.DEAL && !this.props.isCustomForm &&
                            <div className="row row-reverse mt-l">
                                <DKButton
                                    className="bg-gray1 border-m"
                                    title={"New Field"}
                                    icon={DKIcons.ic_add}
                                    onClick={this.onCustomFieldAdd}
                                />
                            </div>
                        }
                    </>
                )}
                {this.state.formFields.length === 0 && (
                    <div
                        className="row justify-content-center"
                        style={{ minHeight: 100 }}
                    >
                        <DKSpinner title="Loading form fields..." />
                    </div>
                )}
            </Popup>
        );
    }
    putAdditionalFields = () => {
        switch (this.props.tableName) {
            case TABLES.ADD_PAYROLL:
                this.updateFormOptions();
                return Promise.resolve();
            default:
                return Promise.resolve();
        }
    };
    onCustomFieldAdd = () => {
        showAddColumnPopup({ tableName: this.props.tableName }, () => {
            this.buildForm(true);
        });
    }

    updateFormOptions() {
        let countryCode = TenantService.get(TENANT.COUNTRY_CODE)
        this.columns.forEach(column => {
            switch (column.columnCode) {
                case COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE:
                    column["options"] = this.paySchedules;
                    break;
                case COLUMN_CODE.ADD_PAYROLL.PAY_DAY:
                    let columnCode = TableManger.getColumnId(TABLES.ADD_PAYROLL,COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD)
                    let workWeekColumnCode = TableManger.getColumnId(TABLES.ADD_PAYROLL,COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK)
                    // column["options"] = payDayMonthly;
                    let payPeriodType = this.defaultValues[columnCode][0]
                    switch(payPeriodType) {
                        case "monthly":
                        case 0:
                            column["options"] = payDayMonthly;
                            break;
                        case "weekly":
                        case 1:
                            let selectedWorkWeek = this.defaultValues[workWeekColumnCode]
                            let options = []
                            
                            workWeek.forEach((w,ind)=>{
                                let i = selectedWorkWeek.findIndex(res=>w.id==res)
                                if(ind == 0 || i!=-1) {
                                    options.push(w)
                                }
                            })
                            column["options"] = options
                            break;
                        case "twicePerMonth":
                        case 2:
                            column["options"] = payDayTwicePerMonthDays
                            break;
                        case "biWeekly":
                        case 3:
                            let biWeeklyPayDaysList = []
                            let selectedWeek = this.defaultValues[workWeekColumnCode]
                            
                            selectedWeek.forEach((workDay,ind)=>{
                                if(workDay){
                                    biWeeklyPayDays.forEach((day, i) => {
                                    if ((workDay) === (i) || (workDay+7) === i) {
                                        biWeeklyPayDaysList.push(day);
                                    }
                                    });
                                }
                            })
                             
                            column["options"] = biWeeklyPayDaysList;
                            break;
                        default:
                            column["options"] = payDayMonthly;
                            break;
                    }
                    break;
                case COLUMN_CODE.ADD_PAYROLL.USERS:
                    const processedData = PayrollManager.parseUserList(this.usersList);
                    column["options"] = processedData;
                    break;
                case COLUMN_CODE.ADD_PAYROLL.LOCATION:
                    const { isLocationActive, locationLabel } = this.getLocationValueAndLabel();
                    const locations = PayrollManager.parseLocationList(this.locationList);
                    column["options"] = locations;
                    column["name"] = locationLabel;
                    break;    
                case COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD:
                    let payPeriodOptions = []
                    switch (countryCode) {
                        case COUNTRY_CODE.INDIA:
                            payPeriodOptions = payPeriod.filter(res => {
                                if (res.id == 'monthly') {
                                    return res
                                }
                            })
                            break;
                        case COUNTRY_CODE.US:
                            payPeriodOptions = payPeriod;
                            break;
                        default:
                            payPeriodOptions = payPeriod;
                            break;
                    }
                    column["options"] = payPeriodOptions
                    break;
            }
        });



        if(this.isUpdated && this.isValueUpdated) {
            this.isValueUpdated = false;
            PayrollManager.getDataToUpdateForPayroll(this.defaultValues, this.columns);
        }
        let isApplicable = this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL)];
        this.updateFormFieldColumns(isApplicable[0]);
    }

    getLocationValueAndLabel = () => {
        const tenantDetails = TenantManager.getTenantDetails();
        let isLocationActive = false;
        let locationLabel = "";
        const additionalSettings = tenantDetails
          ? tenantDetails.additionalSettings
          : "";
        const locationSettings = additionalSettings
          ? additionalSettings?.["LOCATION"]
          : {};
        isLocationActive = locationSettings?.trackLocation || false;
        locationLabel = isLocationActive
          ? locationSettings?.locationLabel
          : "";
    
        return { isLocationActive, locationLabel };
    }

    updateColumnConfigWithCustomField = (columnConfig) => {
        this.customFields.forEach((c) => {
            let group = {};
            group['id'] = c.id;
            group['name'] = c.name;
            group['columnCode'] = c.id;
            group['key'] = c.id;
            group['uiVisible'] = true;
            group['required'] = c.isMandatory;
            group = this.getFieldConfigOnType(group, c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    getFieldConfigOnType = (group, c) => {
        switch(c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                group['validation'] = [{maxLength:c.maxLength}];
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                group['validation'] = [{decimalPrecision:c.decimalPrecision}];
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return{
                        id:p,
                        name:p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break;    
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }
}
export const showPayrollPopup = (
    config: { tableName: string; displayName: string; defaultValues?: any; recordId?: string; isCustomForm?: any; inputData?: any },
    onSave: () => void,
    onClose: () => void
) => {
    const id = `add-new-rec-popup-${new Date().getTime()}`;
    let div = document.createElement("div");
    div.className = "app-font";
    div.setAttribute("id", id);
    ReactDOM.render(
        <AddPayrollPopUp
            id={id}
            tableName={config.tableName}
            onSave={onSave}
            onClose={onClose}
            defaultValues={config.defaultValues}
            recordId={config.recordId}
            displayName={config.displayName}
            isCustomForm={config.isCustomForm}
            inputData={config.inputData}
        />,
        document.body.appendChild(div)
    );
};
export default AddPayrollPopUp;
